import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import type { RecommendedVehicle } from '~/contracts/common';

export default function useVehicleAnalyticsAttributes(
  vehicle?: Partial<RecommendedVehicle>
) {
  const vehicleDetails = useGetVehicleDetails();

  return vehicle
    ? JSON.stringify({
        colorsMatch: vehicle.color === vehicleDetails.exteriorColor,
        freeShipping: vehicle.price?.transportCost === 0,
        suggestedVehicleId: vehicle.vehicleId,
        trimsMatch: vehicle.trim === vehicleDetails.trim
      })
    : undefined;
}
